import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { trimProjectReportTemplate } from "../../entities/trimProjectReportTemplate";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, reportTemplates }) =>
    present(
      repository
        .editProjectReportTemplate(
          planzone,
          reportTemplates.map((t) => ({
            ...t,
            ...trimProjectReportTemplate(t),
          })),
        )
        .then(() => ({ planzone, reportTemplates }))
        .catch(() =>
          Promise.reject({
            planzone,
            reportTemplates,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
